var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Action/assignment_ind_black_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet-View/Navigation/Side-nav_Help",
    transform: "translate(-21.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.333333, 207.333333)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 29.3333335 0 29.3333335 29.3333335 0 29.3333335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2222223,6.11111114 L23.2222223,8.55555559 L18.3333334,8.55555559 L18.3333334,6.11111114 L23.2222223,6.11111114 M11,6.11111114 L11,13.4444445 L6.11111114,13.4444445 L6.11111114,6.11111114 L11,6.11111114 M23.2222223,15.888889 L23.2222223,23.2222223 L18.3333334,23.2222223 L18.3333334,15.888889 L23.2222223,15.888889 M11,20.7777779 L11,23.2222223 L6.11111114,23.2222223 L6.11111114,20.7777779 L11,20.7777779 M25.6666668,3.66666668 L15.888889,3.66666668 L15.888889,11 L25.6666668,11 L25.6666668,3.66666668 Z M13.4444445,3.66666668 L3.66666668,3.66666668 L3.66666668,15.888889 L13.4444445,15.888889 L13.4444445,3.66666668 Z M25.6666668,13.4444445 L15.888889,13.4444445 L15.888889,25.6666668 L25.6666668,25.6666668 L25.6666668,13.4444445 Z M13.4444445,18.3333334 L3.66666668,18.3333334 L3.66666668,25.6666668 L13.4444445,25.6666668 L13.4444445,18.3333334 Z",
    id: "Shape",
    fill: "#232323",
    fillRule: "nonzero"
  }))))));
}
export default SvgDashboardBlack24Dp;